export default "__VITE_ASSET__CgK7xguX__"